var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256.1 124.5c-72.6 0-131.4 58.8-131.4 131.4 0 72.6 58.8 131.4 131.4 131.4 72.6 0 131.4-58.8 131.4-131.4 0-72.6-58.9-131.4-131.4-131.4zm0 216.7c-47.1 0-85.3-38.2-85.3-85.3s38.2-85.3 85.3-85.3 85.3 38.2 85.3 85.3c0 47.1-38.2 85.3-85.3 85.3z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.6 1.6c-47.1-2.2-163.8-2.1-210.9 0-41.5 2-78 12-107.5 41.4C-6 92.3.3 158.6.3 255.9c0 99.6-5.5 164.4 42.9 212.9 49.4 49.4 116.7 42.9 212.9 42.9 98.6 0 132.7.1 167.6-13.4 47.4-18.4 83.2-60.8 86.7-136.9 2.2-47.1 2.1-163.8 0-210.9C506.2 60.6 457.9 6.1 361.6 1.6zm74.5 434.6c-32.3 32.3-77.1 29.4-180.7 29.4-106.7 0-149.4 1.6-180.7-29.7-35.9-35.8-29.4-93.2-29.4-180.3 0-117.9-12.1-202.8 106.2-208.8 27.2-1 35.2-1.3 103.6-1.3l1 .6c113.7 0 202.9-11.9 208.2 106.4 1.2 27 1.5 35.1 1.5 103.4 0 105.4 2 148.5-29.7 180.3z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.7,
    cy: 119.4,
    r: 30.7,
    style: {
      fill: "#d1d1d1"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a14700dd494174f6cc707e7eb6b1a2a0.svg";
export { ForwardRef as ReactComponent };